import { render, staticRenderFns } from "./DeliveryFile.vue?vue&type=template&id=18f68486&"
import script from "./DeliveryFile.vue?vue&type=script&lang=ts&"
export * from "./DeliveryFile.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryFile.vue?vue&type=style&index=0&id=18f68486&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports